// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"250":"7be40514","293":"ee0bd75f","313":"6a705692","445":"bff25674","907":"88b00c67"}[chunkId] + ".chunk.js";
};